import { InMemoryDbService, provideInMemoryWebApi } from 'angular-in-memory-web-api';
import { makeSharedCoreFeature, SharedCoreFeatureKind } from '../../provide-shared-core';
import { FakeBackendConfigProvider } from './fake-backend-config.provider';
import { FakeDbImplService } from './fake-db-impl.service';
import { FakeDbService } from './fake-db.service';
import { FeatureDbProvider } from './feature-flag-dev-dataset';

export function withInMemoryApi() {
  return makeSharedCoreFeature(SharedCoreFeatureKind.InMemoryApi, [
    provideInMemoryWebApi(FakeDbImplService),
    FeatureDbProvider,
    FakeBackendConfigProvider,
    { provide: FakeDbService, useExisting: InMemoryDbService }
  ]);
}
